import { Component, inject } from '@angular/core';
import { DfInsertIconDirective } from '@design-factory/design-factory';
import { NgbToast } from '@ng-bootstrap/ng-bootstrap';
import { ToastNotificationsService } from './toast-notifications.service';

@Component({
  selector: 'ama-ng-app-store-toast-notifications',
  standalone: true,
  imports: [
    DfInsertIconDirective,
    NgbToast,
  ],
  template: `
    @for (notification of toastService.notifications(); track notification.message) {
      <div class="floating-centered-container">
        <ngb-toast dfInsertToastIcon
                   class="df-toast-subtle floating-centered-toast my-3"
                   [class.toast-success]="notification.type === 'success'"
                   [class.toast-danger]="notification.type === 'danger'"
                   [class.toast-warning]="notification.type === 'warning'"
                   [class.toast-info]="notification.type === 'info'"
                   [autohide]="true"
                   (hidden)="toastService.removeOldest()"
        >
          {{ notification.message }}
        </ngb-toast>
      </div>
    }
  `,
  styles: [
    `.floating-centered-toast {
      transform: translate(-50%, -50%);
    }
    .floating-centered-container{
      left: 50%;
      top: 10%;
      z-index: 999;
      position:fixed;
    }`
  ]
  ,
})
export class ToastNotificationsComponent {
  readonly toastService = inject(ToastNotificationsService);
}
